import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { object, array } from 'prop-types';
import {
  startSetNews,
  startSetWebmasterPromo,
  startSetPromo,
  resetPromo,
  resetWebmasterPromo,
} from '../../actions/news';
import { startSetOffersSettings } from '../../actions/app';
import Layout from '../../components/Layout/Layout';
import Card from '../../components/Card/Card';
import NewsPromoList from '../../components/News/NewsPromoList';
import NewsItem from '../../components/News/NewsItem';
import { FMessage } from '../../hoc/IntlComponents';
import Loader from '../../components/Loader/Loader';
import { newsConstants } from '../../constants/news';

class SingleNewsPage extends Component {
  static propTypes = {
    news: object.isRequired,
    promotions: array,
    webmasterPromotions: array,
  };

  static defaultProps = {
    news: {},
    promotions: [],
    webmasterPromotions: [],
  };

  state = {
    loading: false,
    // 2 - All, 1 - For me
    currentTab: 2,
    // Page for all promos request params
    specialOffersPage: 1,
    // Page for my promos request params
    mySpecialOffersPage: 1,
    loadingMoreSpecialOffers: false,
  };

  componentDidMount() {
    const { match, news } = this.props;
    const newsId = parseInt(match.params.id, 10);
    const promoParams = { limit: 5, page: 0 };

    if (news.id === newsId) {
      this.props
        .startSetWebmasterPromo(promoParams)
        .then(() => this.props.startSetPromo(promoParams));
    } else {
      if (!isNaN(newsId)) {
        this.setState(() => ({ loading: true }));

        this.props
          .setNews(newsId)
          .then((resp) => {
            if (resp.type === newsConstants.SET_NEWS_FAILURE) {
              return Promise.reject(this.props.history.push('/404'));
            }
            this.props.startSetOffersSettings();
          })
          .then(() => this.props.startSetWebmasterPromo(promoParams))
          .then(() => this.props.startSetPromo(promoParams))
          .then(() => this.setState(() => ({ loading: false })));
      }
    }
  }

  componentWillUnmount() {
    this.props.resetPromo();
    this.props.resetWebmasterPromo();
  }

  loadMoreSpecialOffers() {
    this.setState(
      () => ({ loadingMoreSpecialOffers: true }),
      () => {
        if (this.state.currentTab === 2) {
          this.props
            .startSetPromo({ limit: 5, page: this.state.specialOffersPage })
            .then(() =>
              this.setState((prev) => ({ specialOffersPage: prev.specialOffersPage + 1 })),
            )
            .then(() => this.setState({ loadingMoreSpecialOffers: false }));
        } else {
          this.props
            .startSetWebmasterPromo({ limit: 5, page: this.state.mySpecialOffersPage })
            .then(() =>
              this.setState((prev) => ({ mySpecialOffersPage: prev.mySpecialOffersPage + 1 })),
            )
            .then(() => this.setState({ loadingMoreSpecialOffers: false }));
        }
      },
    );
  }

  render() {
    const { news, webmasterPromotions, promotions, offerSettings, theme } = this.props;
    const { loading } = this.state;
    const navItems = [
      <FormattedMessage id="news.tabs.all_news" defaultMessage="All" />,
      <FormattedMessage id="news.tabs.my_news" defaultMessage="For me" />,
    ];
    const promoPanes = [
      <NewsPromoList promotions={webmasterPromotions} inNewsItem />,
      <NewsPromoList promotions={promotions} inNewsItem />,
    ];

    return (
      <Layout title={news.title} className="news-layout">
        <Layout.Col>
          <Card.Header>
            <Breadcrumb>
              <BreadcrumbItem>
                <Link to="/news/">
                  <FormattedMessage id="news.breadcrumb" defaultMessage="All news" />
                </Link>
              </BreadcrumbItem>
              <BreadcrumbItem>{news.title}</BreadcrumbItem>
            </Breadcrumb>
          </Card.Header>
        </Layout.Col>
        {/* {theme === 3 && <Layout.Col><h3 className='page-title'><FMessage id='pages.news.title' /></h3></Layout.Col>} */}
        <Layout.LeftCol className="left-col col">
          <Card loading={loading} className="news-wrapper">
            {news.id && <NewsItem {...news} offerSettings={offerSettings} />}
          </Card>
        </Layout.LeftCol>
        <Layout.RightCol className="right-col col">
          <Card.Tabs
            className="news-promo-wrapper"
            title="news.special.title"
            defaultMessage="Special offers"
            navItems={navItems}
            panes={promoPanes}
            loading={loading}
            noPadding
            activeTab={this.state.currentTab}
            onTabChange={() =>
              this.setState((prev) => ({ currentTab: prev.currentTab === 1 ? 2 : 1 }))
            }
          >
            {!loading && (
              <button
                type="button"
                className="btn btn-primary btn-with-loader position-relative mx-auto mb-4"
                onClick={() => this.loadMoreSpecialOffers()}
                disabled={this.state.loadingMoreSpecialOffers}
              >
                <FormattedMessage
                  id="news.special.load-more"
                  defaultMessage="More special offers"
                />
                {this.state.loadingMoreSpecialOffers && <Loader isInButton small />}
              </button>
            )}
          </Card.Tabs>
        </Layout.RightCol>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  theme: state.webmaster.profile.theme,
  news: state.news.selected,
  promotions: state.news.promotions,
  webmasterPromotions: state.news.myPromotions,
  offerSettings: state.app.settings.offer,
});

const mapDispatchToProps = (dispatch) => ({
  setNews: (newsId) => dispatch(startSetNews(newsId)),
  startSetWebmasterPromo: (params) => dispatch(startSetWebmasterPromo(params)),
  startSetPromo: (params) => dispatch(startSetPromo(params)),
  startSetOffersSettings: () => dispatch(startSetOffersSettings()),
  resetPromo: () => dispatch(resetPromo()),
  resetWebmasterPromo: () => dispatch(resetWebmasterPromo()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SingleNewsPage);
